/* global analyticsLib */

const currentURL = window.location.href;
const env = currentURL.startsWith('https://www') ? 'Prod' : 'Dev';

function capitalizeString(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function getCardName() {
  const parsedUrl = new URL(currentURL);
  const grupo = parsedUrl.searchParams.get('grupo');
  const tipo = parsedUrl.searchParams.get('tipo');
  return `${capitalizeString(grupo)} ${capitalizeString(tipo)}`;
}

export function click_next_step1() {
  window['analyticsData'] = {
    event: 'custom_interaction',
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Siguiente(Empezar)',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function click_next_step2() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E1
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Siguiente(Documento)',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function click_next_step3() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E1
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Siguiente(Validar)',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function click_next_step4() {
  //E1
  window['analyticsData'] = {
    event: 'custom_interaction', //E1
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Siguiente(Domicilio)',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function click_next_step5() {
  //E1
  window['analyticsData'] = {
    event: 'custom_interaction', //E1
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Siguiente(ComoQueres)',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function click_next_step6() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E1
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Siguiente(Retirar)',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function click_next_step7() {
  //E1
  window['analyticsData'] = {
    event: 'custom_interaction', //E1
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Siguiente(Recibir)',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function click_next_step8() {
  //E1
  window['analyticsData'] = {
    event: 'custom_interaction', //E1
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Siguiente(LugarRetiro)',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function click_submit() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E1
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Siguiente(ConfirmarDatos)',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function click_submit_files() {
  //E1
  window['analyticsData'] = {
    event: 'custom_interaction', //E1
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Enviar(Datos)',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function click_finish() {
  //E1
  window['analyticsData'] = {
    event: 'custom_interaction', //E1
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Terminar',
      action: 'Solicitar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'HomeBanking',
      country: 'UY',
      environment: env,
      family: 'Tarjetas',
      subfamily: 'SolicitudTarjetas',
      techspec_id: 'ofe7s4yrb3t6fvkcgbe8',
      transaction_name: getCardName(),
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}
